export const OFFERS_HUB_OFFER_TAGS = ['partner_offer', 'luxury_escapes_offer'] as const;
export const OFFERS_HUB_URGENCY_TYPES = ['none', 'limited_time', 'countdown'] as const;

export type OffersHubOfferTag = (typeof OFFERS_HUB_OFFER_TAGS)[number];

export type OffersHubUrgencyType = (typeof OFFERS_HUB_URGENCY_TYPES)[number];

export interface OffersHubHeroCarouselItem {
  draftId: string;
  draftLabel: string;
  isActive: boolean;
  eligibleRegions: Array<string>;
  startAt: string;
  endAt: string;
  label: string;
  imageId: string;
  logoImageId: string;
  title: string;
  description: string;
  ctaLabel: string;
  ctaUrl: string;
}

export interface OffersHubOffer {
  draftId: string;
  draftLabel: string;
  isActive: boolean;
  eligibleRegions: Array<string>;
  startAt: string;
  endAt: string;
  offerTag: OffersHubOfferTag;
  brandName: string;
  industry: string;
  imageId: string;
  title: string;
  description: string;
  ctaLabel: string;
  ctaUrl: string;
  urgencyType: OffersHubUrgencyType;
}

export interface OffersHubPayloadBuilderState {
  mode?: 'offersHub';
  heroCarouselItems: Array<OffersHubHeroCarouselItem>;
  offers: Array<OffersHubOffer>;
}
